import { render, staticRenderFns } from "./UserLevelRecord.vue?vue&type=template&id=58ec5da2&scoped=true"
import script from "./UserLevelRecord.vue?vue&type=script&lang=js"
export * from "./UserLevelRecord.vue?vue&type=script&lang=js"
import style0 from "./UserLevelRecord.vue?vue&type=style&index=0&id=58ec5da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ec5da2",
  null
  
)

export default component.exports